import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import i1 from "../../../Assets/images/authBg.png";
import { Link } from "react-router-dom";
import Profile from "./Profile/Profile";
import EditProfile from "./EditProfile";
import ManagePassword from "./ManagePassword";
import { catchAsync, checkResponse } from "../../../utilities/utilities";
import { GET_PROFILE } from "../../../services/ApiCalls";
import Loader from "../../../components/Common/Loader";

export const profileScreenEnum = {
  profileView: "profileView",
  editProfile: "editProfile",
  changePassword: "changePassword",
};

const Settings = () => {
  const [profileScreen, setProfileScreen] = useState(
    profileScreenEnum.profileView
  );
  const [loading, setLoader] = useState(false);

  const [profileData, setProfileData] = useState();

  const getData = catchAsync(async () => {
    setLoader(true)
    const res = await GET_PROFILE();
    console.log(res,"resposne ====77777===<>")
    checkResponse({ res, setData: setProfileData, setLoader });
  }, setLoader);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
    {loading && <Loader/>}
      {profileScreen === profileScreenEnum.profileView && (
        <Profile
          profileScreen={profileScreen}
          setProfileScreen={setProfileScreen}
          profileData={profileData}
        />
      )}
      
      {profileScreen === profileScreenEnum.editProfile && (
        <EditProfile
          profileScreen={profileScreen}
          setProfileScreen={setProfileScreen}
          profileData={profileData}
          setProfileData={setProfileData}
        />
      )}

      {profileScreen === profileScreenEnum.changePassword && (
        <ManagePassword
          profileScreen={profileScreen}
          setProfileScreen={setProfileScreen}
        />
      )}
    </>
  );
};

export default Settings;
